module.exports = __webpack_public_path__ + "img/_ico2.765e29d9.svg";